
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/convert-twitter-threads-to-videos",
      function () {
        return require("private-next-pages/convert-twitter-threads-to-videos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/convert-twitter-threads-to-videos"])
      });
    }
  